/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as HelpRouteImport } from "./routes/help"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as LegalPrivacyRouteImport } from "./routes/legal.privacy"

const HelpRoute = HelpRouteImport.update({
  id: "/help",
  path: "/help",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
  id: "/legal/privacy",
  path: "/legal/privacy",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/help": typeof HelpRoute
  "/legal/privacy": typeof LegalPrivacyRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/help": typeof HelpRoute
  "/legal/privacy": typeof LegalPrivacyRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/help": typeof HelpRoute
  "/legal/privacy": typeof LegalPrivacyRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: "/" | "/help" | "/legal/privacy"
  fileRoutesByTo: FileRoutesByTo
  to: "/" | "/help" | "/legal/privacy"
  id: "__root__" | "/" | "/help" | "/legal/privacy"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HelpRoute: typeof HelpRoute
  LegalPrivacyRoute: typeof LegalPrivacyRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/help": {
      id: "/help"
      path: "/help"
      fullPath: "/help"
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/legal/privacy": {
      id: "/legal/privacy"
      path: "/legal/privacy"
      fullPath: "/legal/privacy"
      preLoaderRoute: typeof LegalPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HelpRoute: HelpRoute,
  LegalPrivacyRoute: LegalPrivacyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
